export const state = () => ({
    filters: [],
    filterCondition: 'OR',
    showUnselectedOptions: true,
    fullConversation: null,
});

export const getters = {
    optionFiltersPayload: (state) => {
        const result = [];
        const tempObject = {};
        state.filters.forEach((item) => {
            const [optionId, column] = `${item}`.includes("|")
                ? item.split("|")
                : `${item}|`.split("|");
            if (tempObject.hasOwnProperty(optionId) && column) {
                tempObject[optionId].columns.push(Number(column));
            } else {
                tempObject[optionId] = {
                    option_id: Number(optionId),
                };
                if (column) {
                    tempObject[optionId].columns = [Number(column)];
                }
            }
        });
        for (const optionId in tempObject) {
            result.push(tempObject[optionId]);
        }
        return result;
    },
};

export const mutations = {
    SET_ANALYSIS_VIEW_STATE_PROPERTY(state, payload) {
        state.showUnselectedOptions = payload;
    },
    SET_FULL_CONVERSATION(state, payload) {
        state.fullConversation = payload;
    },
    SET_ANALYSIS_VIEW_STATE(state) {
        state.showUnselectedOptions = !state.showUnselectedOptions;
    },
    RESET_FILTERS(state) {
        state.filters = [];
        state.filterCondition = 'OR';
    },
    SET_FILTER_CONDITION(state, condition) {
        state.filterCondition = condition === 'AND' ? 'AND' : 'OR';
    },
    SET_FILTERS(state, data) {
        const index = state.filters.indexOf(data);
        if (index === -1) {
            state.filters.push(data);
        } else {
            state.filters.splice(index, 1);
        }
    }
};

